import React from "react";
import SongList from "./SongList";

const Sidebar = ({ songs, playSong }) => {
  return (
    <div className="w-full px-4 space-y-2 mx-auto">
      <SongList songs={songs} playSong={playSong} />
    </div>
  );
};

export default Sidebar;
